module.exports = __webpack_public_path__ + "img/20.1ab9546f.png";